import { actions, makePropGetter, useGetLatest, } from 'react-table';
const REORDER_ACTIONS = {
    columnDragStart: 'columnDragStart',
    columnDragEnd: 'columnDragEnd',
};
export const useColumnDragAndDrop = (isEnabled) => (hooks) => {
    hooks.getDragAndDropProps = [defaultGetDragAndDropProps(isEnabled)];
    hooks.stateReducers.push(reducer);
    hooks.useInstance.push(useInstance);
};
const defaultGetDragAndDropProps = (isEnabled) => (props, { instance, header, }) => {
    if (!isEnabled || header.disableReordering) {
        return props;
    }
    const onDragStart = () => {
        instance.dispatch({
            type: REORDER_ACTIONS.columnDragStart,
            columnIndex: instance.flatHeaders.indexOf(header),
        });
    };
    const setOnDragColumnStyle = (event, position) => {
        const columnElement = event.currentTarget;
        columnElement.classList.remove('iui-table-reorder-column-right');
        columnElement.classList.remove('iui-table-reorder-column-left');
        if (position === 'left') {
            columnElement.classList.add('iui-table-reorder-column-left');
        }
        else if (position === 'right') {
            columnElement.classList.add('iui-table-reorder-column-right');
        }
    };
    const reorderColumns = (tableColumns, srcIndex, dstIndex) => {
        const newTableColumns = [...tableColumns];
        const [removed] = newTableColumns.splice(srcIndex, 1);
        newTableColumns.splice(dstIndex, 0, removed);
        return newTableColumns;
    };
    const onDragOver = (event) => {
        event.preventDefault();
        const headerIndex = instance.flatHeaders.indexOf(header);
        if (instance.state.columnReorderStartIndex !== headerIndex) {
            setOnDragColumnStyle(event, instance.state.columnReorderStartIndex > headerIndex
                ? 'left'
                : 'right');
        }
    };
    const onDragLeave = (event) => {
        setOnDragColumnStyle(event);
    };
    const onDrop = (event) => {
        event.preventDefault();
        setOnDragColumnStyle(event);
        const columnIds = instance.flatHeaders.map((x) => x.id);
        const srcIndex = instance.state.columnReorderStartIndex;
        const dstIndex = columnIds.findIndex((x) => x === header.id);
        if (srcIndex === dstIndex || srcIndex === -1 || dstIndex === -1) {
            return;
        }
        instance.setColumnOrder(reorderColumns(columnIds, srcIndex, dstIndex));
        instance.dispatch({
            type: REORDER_ACTIONS.columnDragEnd,
            columnIndex: -1,
        });
    };
    return [
        props,
        {
            draggable: true,
            onDragStart,
            onDragOver,
            onDragLeave,
            onDrop,
        },
    ];
};
const reducer = (newState, action) => {
    switch (action.type) {
        case actions.init:
            return {
                ...newState,
                columnReorderStartIndex: -1,
            };
        case REORDER_ACTIONS.columnDragStart:
            return {
                ...newState,
                columnReorderStartIndex: action.columnIndex,
            };
        case REORDER_ACTIONS.columnDragEnd:
            return {
                ...newState,
                columnReorderStartIndex: -1,
            };
        default:
            return newState;
    }
};
const useInstance = (instance) => {
    const { flatHeaders, getHooks } = instance;
    const getInstance = useGetLatest(instance);
    flatHeaders.forEach((header) => {
        header.getDragAndDropProps = makePropGetter(getHooks().getDragAndDropProps, {
            instance: getInstance(),
            header,
        });
    });
};
